import React, { Component } from 'react';
import AuthService from '../../services/api/auth';
import LoadingModal from '../../components/LoadingModal';
import { withAlert } from 'react-alert';
import Helper from '../../helpers';

class RedirectPaymentScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            number: '',
            numberCountry: '',
            loading: true,
        };
    }

    requestPaymentUrl() {
        return AuthService.requestPaymentUrl().then(response => {
            this.setState({
                loading: false,
            });
            Helper.post(response.url.url, response.url.params);
        });
    }

    componentDidMount() {
        this.requestPaymentUrl();
    }
    render() {
        return (
            <div className="container-fluid wrapper">
                <LoadingModal loading={true} message={'PAYMENT_LOADING_MESSAGE'} />
            </div>
        );
    }
}
export default withAlert(RedirectPaymentScreen);
